import { DateHelpers } from '@shared/helpers';

export const formatIsoDate = (datetime: string, format: string = 'HH:mm') =>
    datetime ? DateHelpers.formatIsoDate({ date: datetime, format }) : '';
